import { IconButton } from 'app/agriculture/components/Button/Button';
import { TargetIcon } from 'app/agriculture/icons';
import { useFlyTo } from 'app/agriculture/hooks/useFlyTo/useFlyTo';
import './LocationValue.scss';
import { Position } from 'app/agriculture/queries/types/geometry/Position';

export function LocationValue({ location }: { location?: Position | null }) {
    const { flyTo } = useFlyTo();
    if (location == null) return null;

    return (
        <div className="LocationValue">
            <IconButton
                icon={<TargetIcon />}
                variant="inline"
                tooltip="Show on map"
                onClick={() => {
                    flyTo(location).catch((e: unknown) => {
                        console.error(e);
                    });
                }}
            />
            {formatPosition(location)}
        </div>
    );
}

function formatPosition([longitude, latitude]: Position) {
    return `${latitude}, ${longitude}`;
}
